import { render, staticRenderFns } from "./ModalCertificado.vue?vue&type=template&id=3ad52530&scoped=true"
import script from "./ModalCertificado.vue?vue&type=script&lang=js"
export * from "./ModalCertificado.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificado.vue?vue&type=style&index=0&id=3ad52530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad52530",
  null
  
)

export default component.exports